import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress, Typography } from '@mui/material';
import { initializeAuth, setAuthInitialized } from '../store/slices/authSlice';

const AuthBootstrap = ({ children }) => {
  const dispatch = useDispatch();
  const { authInitialized } = useSelector((state) => state.auth);

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    if (accessToken && refreshToken) {
      dispatch(initializeAuth());
    } else {
      dispatch(setAuthInitialized());
    }
  }, [dispatch]);

  if (!authInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#FFF9F0',
        }}
      >
        <CircularProgress size={48} sx={{ color: '#784e3c' }} />
        <Typography sx={{ mt: 2, color: '#666' }}>Chargement...</Typography>
      </Box>
    );
  }

  return children;
};

export default AuthBootstrap;
